import {TimeTrackerService} from '../app/time-tracker-service.service';
import {Field} from './crud/Field';
import {Config} from './crud/Config';
import {ModalFields} from './modal-fields';

export class Reason {
    public id: string;
    public name: string;
    public date: number;
    // @Deprecated
    // public date: String;
    // public dateLong: number;
    public in: string;
    public out: string;

    constructor() {
    }

    static toModelTemplate(reason: Reason, companyId: String) {
        const path = TimeTrackerService.COMPANY_DATA + '/' + companyId + '/' + TimeTrackerService.REASONS;

        const idField = new Field('id', 'id', 'text', false);
        const nameField = new Field('MODEL.REASON.REASON', 'name', 'text', true);
        const dateField = new Field('MODEL.REASON.DATE', 'date', 'date', true);
        const inField = new Field('MODEL.REASON.IN', 'in', 'time', true);
        const outField = new Field('MODEL.REASON.OUT', 'out', 'time', true);

        dateField.class = 'col-6';
        inField.class = 'col-3';
        outField.class = 'col-3';

        if (reason != null) {
            idField.value = reason.id;
            nameField.value = reason.name;
            dateField.value = reason.date;
            inField.value = reason.in;
            outField.value = reason.out;
        } else {
            dateField.value = new Date();
            inField.value = '08:30';
            outField.value = '09:00';
        }

        idField.hidden = true;
        const modalFields = new ModalFields(
            [idField, nameField, dateField, inField, outField],
            new Config(''),
            false, false, false
        );

        modalFields.firebaePath = path;
        return modalFields;
    }
}



// WEBPACK FOOTER //
// ./src/models/Reason.ts